import { useEffect, useState } from "react"
import { useMediaPredicate } from "react-media-hook"
import { CaretRounded } from "@/common/icons/caret"
import classNames from "classnames"
import styles from "./tabs.module.css"

export default function Tabs({ tabs, onSelect, activeTab }) {
  const [hasMounted, setMounted] = useState(false)
  const isMobile = useMediaPredicate("(max-width: 768px)")

  // This is used due to isMobile not working before mount
  useEffect(() => {
    let isMounted = true
    if (isMounted) {
      setMounted(true)
    }
    return () => {
      isMounted = false
    }
  }, [])

  if (!hasMounted) {
    return null
  }

  if (tabs === undefined || tabs.length === 0) {
    return null
  }

  return (
    <>
      {!isMobile && (
        <ul className={styles.tabs}>
          {tabs.map((tab, i) => {
            const key = "tab-" + i
            const classes = { tab: true, active: activeTab === tab.slug }
            return (
              <li
                key={key}
                className={classNames(classes)}
                onClick={() => onSelect(tab.slug)}>
                {tab.label}
              </li>
            )
          })}
        </ul>
      )}
      {isMobile && (
        <div className={styles.select}>
          <select onChange={(e) => onSelect(e.target.value)} value={activeTab}>
            {tabs.map((tab) => (
              <option key={tab.slug} value={tab.slug}>
                {tab.label}
              </option>
            ))}
          </select>
          <CaretRounded className="caret"></CaretRounded>
        </div>
      )}
    </>
  )
}
